// extracted by mini-css-extract-plugin
export default {"customButton":"CreateButton_customButton__RqL2S"};